import { gql, useQuery } from 'urql';

const GET_PROJECT_TYPES_QUERY = gql`
  query GetProjectTypes {
    getProjectTypes
  }
`;

export interface ProjectTypesResponse {
  getProjectTypes: string[];
}

export const useFetchProjectTypes = () => {
  const [{ data, fetching, error }] = useQuery<ProjectTypesResponse>({ query: GET_PROJECT_TYPES_QUERY });

  const projectTypes = data?.getProjectTypes;

  return { fetching, error, projectTypes };
};
